import { motion, useScroll, useTransform } from "framer-motion";
import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

const Header = () => {
  const { scrollY } = useScroll();
  const [hidden, setHidden] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const location = useLocation();

  // Check if we're on pod-related pages or partner page
  const isPodPage = location.pathname === '/pods' || location.pathname === '/pod-add' || location.pathname.startsWith('/pod/');
  const isPartnerPage = location.pathname === '/partner';
  
  // Check if we're on legal pages (terms or privacy policy)
  const isLegalPage = location.pathname === '/terms' || location.pathname === '/privacy-policy';

  // Handle scroll direction detection
  useEffect(() => {
    const updateScrollDirection = () => {
      const currentScrollY = window.scrollY;
      setHidden(currentScrollY > lastScrollY && currentScrollY > 100);
      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", updateScrollDirection);
    return () => window.removeEventListener("scroll", updateScrollDirection);
  }, [lastScrollY]);

  // Opacity for the header background
  const headerBgOpacity = useTransform(scrollY, [0, 100], [0, 0.95]);

  // On partner/pod pages with dark hero, use white initially
  const shouldUseWhiteInitially = isPodPage || isPartnerPage;

  // For legal pages, show simplified header with logo on right
  if (isLegalPage) {
    return (
      <motion.header
        className="fixed top-0 left-0 right-0 z-50 transition-transform duration-300"
        style={{
          transform: hidden ? "translateY(-100%)" : "translateY(0)",
        }}
      >
        <motion.div
          className="absolute inset-0 bg-background"
          style={{ opacity: headerBgOpacity }}
        />
        <div className="relative z-10 mx-auto px-4 desktop:px-24 laptop:px-20 tablet:px-12 mobile:px-6">
          <div className="flex items-center justify-end desktop:py-6 laptop:py-6 tablet:py-6 mobile:py-3">
            <Link to="/">
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
                className="font-funnel font-semibold text-2xl text-primary"
              >
                qwip
              </motion.div>
            </Link>
          </div>
        </div>
      </motion.header>
    );
  }

  return (
    <motion.header
      className="fixed top-0 left-0 right-0 z-50 transition-transform duration-300"
      style={{
        transform: hidden ? "translateY(-100%)" : "translateY(0)",
      }}
    >
      <motion.div
        className="absolute inset-0 bg-background"
        style={{ opacity: headerBgOpacity }}
      />
      <div className="relative z-10 mx-auto px-4 desktop:px-24 laptop:px-20 tablet:px-12 mobile:px-6">
        <div className="flex items-center justify-between desktop:py-6 laptop:py-6 tablet:py-6 mobile:py-3">
          <Link to="/">
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
              className={`font-funnel font-semibold text-2xl ${shouldUseWhiteInitially ? 'text-white' : 'text-primary'}`}
            >
              qwip
            </motion.div>
          </Link>
          
          {/* Navigation */}
          <nav className="hidden tablet:flex laptop:flex desktop:flex items-center gap-6">
            <a 
              href="#how-it-works" 
              className={`text-sm font-medium ${shouldUseWhiteInitially ? 'text-white' : 'text-primary'}`}
            >
              Learn more
            </a>
          </nav>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;
